module.exports = __webpack_public_path__ + "img/w8.36a757ee.svg";